import "./TooltipIndicator_module.css";
const TooltipIndicator_module = {
    tooltipIndicator: "tooltipIndicator__75e58fa1dc918bea"
};
export { TooltipIndicator_module as default };
